import {WidgetNamesForErrorLogs} from 'widgets/helpers/widgetErrorHandlers'
import {initWidget} from 'widgets/initWidget'

import {HotelCardWidget} from './HotelCardWidget'

initWidget(HotelCardWidget, WidgetNamesForErrorLogs.hotelCard)
